export default "__VITE_ASSET__DB5xjBlh__"